import { FC, ReactElement } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Grid, Tooltip } from '@mui/material';

import styles from './DetailsTopPanel.module.scss';
import { IHospitalDetails } from '~/services/api/hospital/types';
import { isoToFormat } from '~/utils/date';
import { DATE_TIME_FORMAT, EMPTY_VALUE } from '../constants';

export interface IProps {
  eventLabel: string;
  details: IHospitalDetails;
}

const DetailsTopPanel: FC<IProps> = ({ details, eventLabel }): ReactElement => {
  const formattedDateTime = details.admitDateTime
    ? isoToFormat(details.admitDateTime, DATE_TIME_FORMAT, details.patientTimezone)
    : EMPTY_VALUE;

  return (
    <div className={styles.topPanel}>
      <Grid container wrap="nowrap" alignItems="center" gap={1} className={styles.topPanelRow}>
        <Grid item className={styles.fixedItem}>
          <PersonIcon className={styles.userIcon} />
        </Grid>
        <Grid item className={styles.fixedItem}>
          <span className={styles.patientName}>{details.patientFullName}</span>
        </Grid>
        {details.isInFacility && (
          <Grid item className={styles.fixedItem}>
            <span className={styles.tag}>In Facility</span>
          </Grid>
        )}

        <Grid item xs />

        <Grid item className={styles.fixedItem}>
          <span className={styles.tag}>{`${eventLabel}: ${formattedDateTime}`}</span>
        </Grid>
        <Grid item className={styles.fixedItem}>
          <ArrowForwardIcon className={styles.arrowIcon} />
        </Grid>
        <Grid item className={styles.ellipsisItem}>
          <Tooltip title={details.facility || EMPTY_VALUE} placement="top">
            <span className={styles.tagEllipsis}>
              <span className={styles.tagText}>
                {`Facility: ${details.facility || EMPTY_VALUE}`}
              </span>
            </span>
          </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
};

export default DetailsTopPanel;
